import { render, staticRenderFns } from "./ChatbotSandbox.vue?vue&type=template&id=4ebc2e69&scoped=true"
import script from "./ChatbotSandbox.vue?vue&type=script&lang=js"
export * from "./ChatbotSandbox.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSandbox.vue?vue&type=style&index=0&id=4ebc2e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc2e69",
  null
  
)

export default component.exports